<template>
  <el-select
    v-model="innerVal"
    filterable
    clearable
    :multiple="multiple"
    :collapse-tags="collapseTags"
    :placeholder="placeholder"
    :size="size"
  >
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
import api from "@/interface";
import { deepCopy } from "@/utils/assist";
import { hashRateFormat, fixed8 } from "@/utils/assist";

export default {
  name: "enum-select",
  props: {
    size: {
      type: String,
      default: "small"
    },
    placeholder: {
      type: String,
      default: "Please Select"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Array]
    },
    type: {
      validator: function(value) {
        return true;
      }
    },
    filter: {
      fixed8,
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      options: [],
      innerVal: undefined,
      loading: false
    };
  },
  watch: {
    value(val) {
      this.innerVal = val;
    },
    innerVal(val) {
      this.$emit("input", val);
    },
    filter: {
      handler(val) {
        this.remoteMethod();
      },
      deep: true
    },
    type: {
      handler(val) {
        this.remoteMethod();
      },
      deep: true
    }
  },
  created() {
    this.remoteMethod();
  },
  filters: {
    hashRateFormat
  },
  methods: {
    rsFormat(list) {
      switch (this.type) {
        case "game_chain":
          this.options = list.map(itm => ({
            value: itm.key,
            label: itm.title + "(" + itm.key + ")"
          }));
          break;
        default:
          this.options = list.map(itm => ({
            value: itm.key,
            label: itm.title
          }));
          break;
      }
    },
    remoteMethod(queryString) {
      this.loading = true;
      let filter = deepCopy(this.filter);
      filter.type = this.type;
      filter.query = queryString;
      api.senum
        .getList(filter)
        .then(res => {
          try {
            const {
              data: { list }
            } = res;
            this.rsFormat(list);
          } catch (err) {}
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
